import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  activeUserLabel: '',
  activeUserOID: '',
  searchParms: {
    claimCategory: 'Last claims',
    claimNumber: '',
    claimType: [],
    claimDuration: '',
    sortBy: [{ id: 'ServiceDate', desc: true }],
    startDate: '',
    endDate: '',
    pageSize: 10,
    pageNumber: 1,
  },
  claimsResult: [],
};

export const claimsSlice = createSlice({
  name: 'claims',
  initialState: INITIAL_STATE,
  reducers: {
    setActiveUser: (state, action) => {
      state.activeUserLabel = action.payload.label;
      state.activeUserOID = action.payload.OID;
      state.searchParms = INITIAL_STATE.searchParms;
    },
    resetActiveUser: (state, action) => {
      state.activeUserLabel = INITIAL_STATE.activeUserLabel;
      state.activeUserOID = INITIAL_STATE.activeUserOID;
    },
    setSearchParams: (state, action) => {
      state.searchParms = { ...state.searchParms, ...action.payload };
    },
    resetSearchParams: (state, action) => {
      state.searchParms = INITIAL_STATE.searchParms;
    },
    setClaimsResult: (state, action) => {
      state.claimsResult = action.payload;
    },
    resetClaimsResult: (state, action) => {
      state.claimsResult = INITIAL_STATE.claimsResult;
    },
    resetPageSizeandNumber: (state, action) => {
      state.searchParms.pageSize = INITIAL_STATE.searchParms.pageSize;
      state.searchParms.pageNumber = INITIAL_STATE.searchParms.pageNumber;
    },
  },
});

export const {
  setActiveUser,
  resetActiveUser,
  setSearchParams,
  resetSearchParams,
  setClaimsResult,
  resetClaimsResult,
  resetPageSizeandNumber,
} = claimsSlice.actions;

export default claimsSlice.reducer;
